module.exports = __webpack_public_path__ + "img/76319.62497a05.svg";